// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ProcessRefundsBatchInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/process_refunds_batch
 *
 * Validates input for processing multiple refund decisions at once.
 * Each decision in the array must have:
 * - refund_id (int): The refund ID
 * - action (string): "accept" or "decline"
 * - categoria_id (int, optional): Required if action is "accept"
 */
import type { PayrollRefundDecisionNestedInput } from './PayrollRefundDecisionNestedInput'
import { registerContract } from './validate'

export interface Payroll_ProcessRefundsBatchInput {
period_id: number
decisions: PayrollRefundDecisionNestedInput[]
}

registerContract('Payroll_ProcessRefundsBatchInput', {
  period_id: { type: 'number',  required: true },
  decisions: {
    type: 'array',
    required: true,
    items: {
      refund_id:    { type: 'number',  required: true },
      action:       { type: 'string',  required: true },
      categoria_id: { type: 'number',  required: false },
      reason:       { type: 'string',  required: false },
    },
  },
})
